var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSparkyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 24,
    viewBox: "0 0 84 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "logo",
    clipPath: "url(#clip0_5103_7785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3376 8.28516C35.0159 8.28516 33.9511 8.92157 33.2045 9.87618L33.4248 8.64008H30.0347L27.7461 22.0414H31.1362L32.1398 16.1057C32.5559 17.2439 33.4248 18.0516 34.8812 18.0516C37.2923 18.0516 39.4218 15.9833 39.7645 13.1684C40.0827 10.4759 38.7487 8.28516 36.3376 8.28516ZM35.9827 14.6248C35.5788 15.0776 35.0648 15.3101 34.4406 15.3101C33.8899 15.3101 33.4493 15.151 33.1189 14.8206C32.7762 14.4902 32.6171 14.0618 32.6171 13.5111C32.6171 12.8012 32.8251 12.2138 33.229 11.7365C33.6329 11.2714 34.1469 11.0266 34.7589 11.0266C35.3096 11.0266 35.7502 11.198 36.0929 11.5284C36.4356 11.8711 36.6069 12.3117 36.6069 12.8747C36.5947 13.5845 36.3866 14.1719 35.9827 14.6248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7836 8.64113L48.5021 10.2199C48.0248 9.15515 47.1069 8.44531 45.7239 8.44531C43.3618 8.44531 41.2078 10.4525 40.8529 13.1817C40.5347 15.7885 41.9544 17.918 44.3287 17.918C45.5648 17.918 46.654 17.3428 47.4618 16.4249L47.2415 17.7222H50.5949L52.1737 8.65337H48.7836V8.64113ZM47.5107 14.6258C47.1069 15.0787 46.5928 15.3112 45.9687 15.3112C45.4179 15.3112 44.9773 15.1521 44.6469 14.8217C44.3042 14.4912 44.1451 14.0629 44.1451 13.5121C44.1451 12.8023 44.3532 12.2148 44.757 11.7375C45.1609 11.2724 45.6749 11.0277 46.2869 11.0277C46.8376 11.0277 47.2782 11.199 47.6209 11.5295C47.9636 11.8721 48.1349 12.3127 48.1349 12.8757C48.1104 13.5855 47.9146 14.173 47.5107 14.6258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2574 11.5908C57.3272 11.5663 56.544 12.5209 56.4093 13.5612V13.5367L55.675 17.6979H52.3828L53.9371 8.62902H57.2538L57.0213 9.97527C57.7066 9.04513 58.6613 8.39648 59.5792 8.39648C60.2523 8.39648 60.7663 8.77588 61.0968 9.22871L59.2854 12.1293C59.0284 11.8478 58.7102 11.5908 58.2574 11.5908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4767 8.64132L67.9362 12.4598L71.1549 17.7102H67.3854L64.5216 13.035L63.7138 17.7102H60.5195L63.1508 2.32617H66.3574L64.7419 11.7377L68.3523 8.64132H72.4767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4893 22.042H72.0625L75.061 17.0608L72.5765 8.64062H76.1257L77.2272 13.6707L80.0421 8.64062H83.5301L75.4893 22.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.848 14.9425C22.6925 14.9425 23.439 14.4897 23.5492 13.7798C23.7083 12.8986 22.7169 12.556 21.2973 11.9685C19.8042 11.2954 18.0295 9.9736 18.2621 7.63602C18.5803 5.05366 21.1259 3.56055 23.8429 3.56055C26.4008 3.56055 27.9184 4.98023 28.616 6.63245L25.6175 8.17452C25.1402 7.30558 24.516 6.75484 23.5492 6.75484C22.8149 6.75484 22.1907 7.07304 22.0928 7.6605C21.9214 8.56616 23.5125 9.01899 24.6996 9.47182C26.5966 10.2061 27.7715 11.6381 27.539 13.6942C27.1841 16.5702 24.4181 18.2347 21.6277 18.2347C19.0209 18.2347 16.977 16.6926 16.2305 14.5509L19.0086 12.6783C19.6206 13.9756 20.514 14.9425 21.848 14.9425Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.05639 9.91384L8.10025 6.26672C8.12472 6.21777 8.1492 6.15658 8.1492 6.09538L8.17368 0.367693C8.17368 -0.0117053 7.68413 -0.134092 7.50055 0.184113L-0.00174266 13.5977C-0.136368 13.8302 6.05639 9.91384 6.05639 9.91384Z",
    fill: "url(#paint0_linear_5103_7785)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08213 14.0864L4.03828 17.7457C4.0138 17.7947 3.98932 17.8559 3.98932 17.9171L3.96484 23.6448C3.96484 24.0242 4.45439 24.1465 4.63797 23.8283L12.1403 10.4025C12.2749 10.17 6.08213 14.0864 6.08213 14.0864Z",
    fill: "url(#paint1_linear_5103_7785)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8487 9.90039H10.9798H6.09657H2.10677L0.0506751 13.5842C-0.0839501 13.829 0.087391 14.1227 0.36888 14.1227H6.10881H10.1108L12.1669 10.4389C12.2893 10.1941 12.118 9.90039 11.8487 9.90039Z",
    fill: "url(#paint2_linear_5103_7785)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5103_7785",
    x1: 4.33914,
    y1: 9.2948,
    x2: 8.40909,
    y2: 2.20572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5300D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8100FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5103_7785",
    x1: 7.80292,
    y1: 14.7074,
    x2: 3.73297,
    y2: 21.7965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5300D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8100FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5103_7785",
    x1: 0.00172045,
    y1: 12.0108,
    x2: 12.2065,
    y2: 12.0108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5300D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8000FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5700D4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5103_7785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.5288,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkyLogo);
export default __webpack_public_path__ + "static/media/sparky-logo.ebb909dcbaf7e52579005a8452387f77.svg";
export { ForwardRef as ReactComponent };